export const CREATE_RIGHTS  = 'CREATE_RIGHTS';
export const GET_RIGHTS  = 'GET_RIGHTS';
export const RIGHTS_REQUEST  = 'RIGHTS_REQUEST';
export const DELETE_RIGHTS  = 'DELETE_RIGHTS';
export const UPDATE_RIGHTS  = 'UPDATE_RIGHTS';
export const RIGHTS_REQUEST_FAILURE  = 'RIGHTS_REQUEST_FAILURE';
export const SET_USER_RIGHTS = 'SET_USER_RIGHTS';
export const GET_AUTHORIZE_COMPANIES = 'GET_AUTHORIZE_COMPANIES';